/* nt-tabs.js — generic step-wizard, toggle-chip and single-select-filter controller.
   Reused by: quote wizard steps, quote wizard placement/type chips, portfolio filters. */
window.NT = window.NT || {};

(function (NT) {
  /* --- multi-step wizard: [data-nt-steps] wrapping [data-nt-step="1|2|3|done"] panels
     and buttons [data-nt-step-next] / [data-nt-step-back] / [data-nt-step-restart] --- */
  function initSteps(root) {
    var wrap = root.querySelector('[data-nt-steps]');
    if (!wrap) return;
    var order = ['1', '2', '3', 'done'];

    function show(step) {
      wrap.setAttribute('data-current-step', step);
      NT.qsa('[data-nt-step]', wrap).forEach(function (panel) {
        panel.hidden = panel.getAttribute('data-nt-step') !== step;
      });
      var progress = wrap.querySelectorAll('[data-nt-step-progress]');
      var idx = order.indexOf(step);
      progress.forEach(function (p, i) {
        p.classList.toggle('is-active', i <= idx);
      });
    }

    wrap.addEventListener('click', function (e) {
      var next = e.target.closest('[data-nt-step-next]');
      var back = e.target.closest('[data-nt-step-back]');
      var restart = e.target.closest('[data-nt-step-restart]');
      if (next) {
        var cur = wrap.getAttribute('data-current-step') || '1';
        var i = order.indexOf(cur);
        if (i < order.length - 2) show(order[i + 1]);
      } else if (back) {
        var cur2 = wrap.getAttribute('data-current-step') || '1';
        var i2 = order.indexOf(cur2);
        if (i2 > 0) show(order[i2 - 1]);
      } else if (restart) {
        show('1');
        var form = wrap.querySelector('form');
        if (form) form.reset();
        NT.qsa('[data-nt-toggle-chip].is-active', wrap).forEach(function (c) { c.classList.remove('is-active'); });
      }
    });

    show(wrap.getAttribute('data-current-step') || '1');
  }

  /* --- multi-select toggle chips: any [data-nt-toggle-chip] toggles its own is-active --- */
  function initToggleChips(root) {
    NT.qsa('[data-nt-toggle-chip]', root).forEach(function (chip) {
      if (chip.dataset.ntToggleInit) return;
      chip.dataset.ntToggleInit = '1';
      chip.addEventListener('click', function () {
        chip.classList.toggle('is-active');
      });
    });
  }

  /* --- single-select filter groups: [data-nt-filter-group="name"] wraps
     [data-nt-filter-btn][data-value]; only one active per group; dispatches
     'nt:filterchange' with {group, value} on the group element --- */
  function initFilterGroups(root) {
    NT.qsa('[data-nt-filter-group]', root).forEach(function (group) {
      if (group.dataset.ntFilterInit) return;
      group.dataset.ntFilterInit = '1';
      group.addEventListener('click', function (e) {
        var btn = e.target.closest('[data-nt-filter-btn]');
        if (!btn) return;
        NT.qsa('[data-nt-filter-btn]', group).forEach(function (b) { b.classList.remove('is-active'); });
        btn.classList.add('is-active');
        group.dispatchEvent(new CustomEvent('nt:filterchange', {
          bubbles: true,
          detail: { group: group.getAttribute('data-nt-filter-group'), value: btn.getAttribute('data-value') }
        }));
      });
    });
  }

  function initAll(root) {
    root = root || document;
    initSteps(root);
    initToggleChips(root);
    initFilterGroups(root);
  }

  NT.Tabs = { initAll: initAll };

  document.addEventListener('DOMContentLoaded', function () { initAll(document); });
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
})(window.NT);
